export const initialState = {
  accordionOpenStatus: {
    businessInfo: true,
    creditCheck: false,
    requiredrefund: false,
    terms: false,
    installment: false,
    installation: false,
    winbackqualified: false,
  },
  contactInfo: {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    unit: '',
    unitType: '',
    businessName: "",
    selectedMailType: "E"
  },
  businessInfo: {
    selected: false,
    address: "",
    city: "",
    state: "",
    zipCode: ""
  },
  shippingInfo: {
    selected: true,
    address: "",
    city: "",
    state: "",
    zipCode: ""
  },
  creditCheck: {
    customerType: '',
    retryCount: 0,
    otpFlow:true,
    otp: {   
      isOtpVerified:false,
      otpVerifiedMobileNo:null,   
      postOtpResponse:{},
      postValidateOtpResponse: {},
    },  
    soleOwner: {
      firstName: '',
      lastName: '',
      middleInitial: '',
      isNoSsn: false,
      dob: '',
      ssn: ''
    },
    partner1: {
      firstName: '',
      lastName: '',
      middleInitial: '',
      isNoSsn: false,
      dob: '',
      ssn: ''
    },
    partner2: {
      firstName: '',
      lastName: '',
      middleInitial: '',
      isNoSsn: false,
      dob: '',
      ssn: ''
    },
    corporation: {
      billingName: '',
      taxIdNumber: ''
    },
    llc: {
      billingName: '',
      taxIdNumber: ''
    },
    scorp: {
      billingName: '',
      taxIdNumber: ''
    }
  },
  installments: {
    oneTimeInstallments: '',
    equipmentInstallments: '12',
    routerInstallments: '',
    routertInstallmentsPrice: '',
    oneTimeInstallmentsPrice: '',
    equipmentInstallmentsPrice: '',
    paperFreeBilling: false,
    autoPay: false,
    paymentMethod: 'BankAccount',
    bankRoutingNumber: '',
    bankAccountNumber: '',
    firstName: '',
    lastName: '',
    cardNumber: '',
    cardType: 'VISA',
    expMonth: '',
    expYear: '',
    cvv: '',
    ccForm: {
      firstName: '',
      lastName: '',
      cardNumber: '',
      cardType: 'VISA',
      expMonth: '01',
      expYear: '',
      cvv: '',
      isDebitCard: false,
      selected: true,
      state: '',
      city: '',
      zipCode: '',
      street: ''
    }
  },
  nextButtonInfo: '',
  checkoutResponse: '',
  SIselected: '',
  dueDate: '',
  timeSlot: '',
  timeSlotCode: '',
  busStartHour: '',
  busEndHour: '',
  tosCheck: false,
  isPersonalInfoSaved: false,
  isCreditCheckInfoSaved: false,
  isRefundableDepositInfoSaved: false,
  isInstallmentsInfoSaved: false,
  isInstallationInfoSaved: false,
  isTosInfosaved: false,
  nextButtonBI: '',
  nextButtonCC: '',
  nextButtonIPM: '',
  appointmentCode: '',
  duedateReserveError: '',
  APEnrolled: false,
  dueDateInfo: {},
  APLoading: false,
  APLoadFailure: false,
  savedCartError: false,
  creditCheckState: {},
  isVOCallInProgress: false,
  saveCartEmail: '',
  isCheckoutInitiated: false,
  isSaveBusinessInfo :false,
  isResetDateChange :true,
  paymentMethodType:"",
  savedPaymentMethodType:"",
  enableVDS3LFCreditCheckProgress:false,
  isCreditCheckLBO: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'TOGGLE_BUSINESSINFO_ACCOR':
      return {
        ...state, accordionOpenStatus: {
          businessInfo: !state.accordionOpenStatus.businessInfo,
          creditCheck: false,
          winbackqualified: false,
          terms: false,
          requiredrefund: false,
          installment: false,
          installation: false
        }
      }
    case 'TOGGLE_CREDITCHECK_ACCOR':
      return {
        ...state, accordionOpenStatus: {
          businessInfo: false,
          creditCheck: !state.accordionOpenStatus.creditCheck,
          winbackqualified: false,
          terms: false,
          requiredrefund: false,
          installment: false,
          installation: false
        }
      }
    case 'TOGGLE_INSTALLMENT_ACCOR':
      return {
        ...state, accordionOpenStatus: {
          businessInfo: false,
          creditCheck: false,
          winbackqualified: false,
          terms: false,
          requiredrefund: false,
          installment: !state.accordionOpenStatus.installment,
          installation: false
        }
      }
    case 'TOGGLE_WINBACKQUALIFIED_ACCOR':
      return {
        ...state, accordionOpenStatus: {
          businessInfo: false,
          creditCheck: false,
          winbackqualified: !state.accordionOpenStatus.winbackqualified,
          terms: false,
          requiredrefund: false,
          installment: false,
          installation: false
        }
      }
    case 'TOGGLE_TERMS_ACCOR':
      return {
        ...state, accordionOpenStatus: {
          businessInfo: false,
          creditCheck: false,
          winbackqualified: false,
          terms: !state.accordionOpenStatus.terms,
          requiredrefund: false,
          installment: false,
          installation: false
        }
      }
    case 'TOGGLE_REQUIREDREFUND_ACCOR':
      return {
        ...state, accordionOpenStatus: {
          businessInfo: false,
          creditCheck: false,
          requiredrefund: !state.accordionOpenStatus.requiredrefund,
          installation: false,
          installment: false,
          winbackqualified: false,
          terms: false
        }
      }
      case "SAVE_BUSINESS_INFO":
        return {
          ...state,
          isSaveBusinessInfo: action.data
        }
  
    case 'TOGGLE_INSTALLATION_ACCOR':
      return {
        ...state, accordionOpenStatus: {
          businessInfo: false,
          creditCheck: false,
          installation: !state.accordionOpenStatus.installation,
          requiredrefund: false,
          installment: false,
          winbackqualified: false,
          terms: false
        }
      }
    case 'SAVE_PERSONAL_INFO':
      return {
        ...state,
        contactInfo: action.data.contactInfo,
        businessInfo: action.data.businessInfo,
        shippingInfo: action.data.shippingInfo,
        email: action.data?.contactInfo?.email
      }
    case 'AUTOFILL_DATA_FOR_CREDITCHECK':
      return {
        ...state,
        creditCheck: {
          ...state.creditCheck,
          soleOwner: {
            ...state.creditCheck.soleOwner,
            firstName: action.data.firstName,
            lastName: action.data.lastName
          },
          partner1: {
            ...state.creditCheck.partner1,
            firstName: action.data.firstName,
            lastName: action.data.lastName
          }
        }
      }
    case 'SAVE_CREDIT_CHECK_INFO':
      return {
        ...state,
        creditCheck: {
          ...state.creditCheck,
          customerType: action.data.customerType,
          soleOwner: {
            ...state.creditCheck.soleOwner,
            ...action.data.soleOwner
          },
          partner1: {
            ...state.creditCheck.partner1,
            ...action.data.partner1
          },
          partner2: {
            ...state.creditCheck.partner2,
            ...action.data.partner2
          },
          corporation: {
            ...state.creditCheck.corporation,
            ...action.data.corporation
          },
          llc:{
            ...state.creditCheck.llc,
            ...action.data.llc
          },
          scorp:{
            ...state.creditCheck.scorp,
            ...action.data.scorp
          }
        }
      }

      case "UPDATE_POST_OTP_RESPONSE": {
        return {
          ...state,
          creditCheck: {
            ...state.creditCheck,          
            otp: {
              ...state.creditCheck.otp,
              postOtpResponse : action.data?.data
            }
          }
        }
      }
  
      case "REMOVE_POST_OTP_RESPONSE": {
        return {
          ...state,
          creditCheck: {
            ...state.creditCheck,          
            otp: {
              ...state.creditCheck.otp,
              postOtpResponse : null
            }
          }
        }
      }
  
      case "UPDATE_POST_VALIDATE_OTP_RESPONSE": {
        return {
          ...state,
          creditCheck: {
            ...state.creditCheck,          
            otp: {
              ...state.creditCheck.otp,
              postValidateOtpResponse : action.data?.data
            }
          }
        }
      }
  
      case "REMOVE_POST_VALIDATE_OTP_RESPONSE": {
        return {
          ...state,
          creditCheck: {
            ...state.creditCheck,          
            otp: {
              ...state.creditCheck.otp,
              postValidateOtpResponse : null
            }
          }
        }
      }

      case "IS_OTP_VERIFIED": {
        return {
          ...state,
          creditCheck: {
            ...state.creditCheck,          
            otp: {
              ...state.creditCheck.otp,
              isOtpVerified : action.data?.data
            }
          }
        }
      }
  
      case "UPDATE_OTP_VERIFIED_MOBILE_NO": {
        return {
          ...state,
          creditCheck: {
            ...state.creditCheck,          
            otp: {
              ...state.creditCheck.otp,
              otpVerifiedMobileNo : action.data?.data
            }
          }
        }
      }

    case "UPDATE_CREDITCHECK_INFO": {
      if (action.data.key === "customerType") {
        return {
          ...state, creditCheck: {
            ...state.creditCheck, [action.data.key]: action.data.value
          }
        }
      } else if (action.data.key === "resetSection") {
        return {
          ...state, creditCheck: {
            ...state.creditCheck,soleOwner:{...initialState.creditCheck.soleOwner},llc:{...initialState.creditCheck.llc},scorp:{...initialState.creditCheck.scorp},corporation:{...initialState.creditCheck.corporation},partner1:{...initialState.creditCheck.partner1},partner2:{...initialState.creditCheck.partner2}
          }
        }
      }else {
        return {
          ...state, creditCheck: {
            ...state.creditCheck, [action.data.type]: {
              ...state.creditCheck[action.data.type], [action.data.key]: action.data.value
            }
          }
        }
      }
    }
    case "UPDATE_INSTALLMENTS_INFO":
      return {
        ...state, installments: {
          ...state.installments, [action.data.key]: action.data.value
        }
      }

    case "UPDATE_SI_INFO":
      return {
        ...state, SelforTechInstall: {
          ...state.SelforTechInstall, [action.data.key]: action.data.value
        }
      }

    case "UPDATE_COVID_INFO":
      return {
        ...state, SetCovid19QuestionValue: {
          ...state.SetCovid19QuestionValue, [action.data.key]: action.data.value
        }
      }

    case "RESERVER_DUE_DATE": {
      return {
        ...state, SetDueDate: action.data
      }
    }

    case "AUTOPAY_LOG": {
      return {
        ...state, autoPayLogResponse: action.data
      }
    }

    case "UPDATE_CC_INFO":
      return {
        ...state, installments: {
          ...state.installments, ccForm: {
            ...state.installments.ccForm, [action.data.key]: action.data.value
          }
        }
      }

    case "SAVE_NEXTBUTTON_INFO":
      return {
        ...state, nextButtonInfo: action.data
      }
    case "SET_DUE_DATES":
      return {
        ...state,
        dueDateInfo: action.data.response
      }

    case "UPDATE_DUE_DATES":
      return {
        ...state,
        dueDateInfo: { ...state.dueDateInfo, ...action.data.response },
        dueDate: ''
      }

    case "SAVE_SUBMITORDER_INFO":
      return {
        ...state, submitOrderInfo: action.data
      }

    case "RESET_SUBMITORDER_INFO":
      return {
        ...state, submitOrderInfo: {}
      }

    case "AUTOPAY_DETAILS":
      return {
        ...state, autopayinfo: action.data
      }

    case "SAVE_AUTOPAYLOG_RESPONSE":
      return {
        ...state, autoPayLogResponse: action.data
      }

    case "UPDATE_TOS_INFO":
      return {
        ...state, [action.data.key]: action.data.value
      }

    case "SAVE_CHECKOUT_EMAIL":
      return {
        ...state,
        contactInfo: { ...state.contactInfo, email: action.data },
      }
    case "SAVE_CHECKOUT_PHONE":
      return {
        ...state,
        contactInfo: { ...state.contactInfo, phoneNumber: action.data },
      }
    case "SAVE_CHECKOUT_BUSINESSNAME":
      return {
        ...state,
        contactInfo: { ...state.contactInfo, businessName: action.data },
      }
    case "SAVE_SAVECART_EMAIL":
      return {
        ...state,
        saveCartEmail: action.data,
      }

    case "SAVE_CHECKOUT_RESPONSE":
      return {
        ...state,
        contactInfo: { ...state.contactInfo, ...action.data.checkoutData.contactInfo },
        businessInfo: { ...state.businessInfo, ...action.data.checkoutData.businessInfo },
        shippingInfo: { ...state.shippingInfo, ...action.data.checkoutData.shippingInfo },
        checkoutResponse: action.data.response
      }

    case "SAVE_CHECKOUT_INSTALLMENTS":
      return {
        ...state,
        checkoutResponse: action.data.response,
        installments: {
          ...state.installments,
          oneTimeInstallmentsPrice: action?.data?.response?.objDOBBind?.InstallmentPrice || state.installments.oneTimeInstallmentsPrice,
          oneTimeInstallments: action?.data?.response?.objDOBBind?.NoofInstall && action?.data?.response?.objDOBBind?.NoofInstall !== "0" ?
            action?.data?.response?.objDOBBind?.NoofInstall : state.installments.oneTimeInstallments,
          routerInstallments: action?.data?.response?.objDOBBind?.BDVInstallmentQualified === 'Y' ? action?.data?.response?.objDOBBind?.BDVInstallmentRadio || state.installments.routerInstallments : state.installments.routerInstallments,

        }
      }

    case "SAVE_BI_VALIDATION_RESPONSE":
      return {
        ...state, nextButtonBI: action.data
      }

    case "SAVE_CC_RESPONSE":
      return {
        ...state, nextButtonCC: action.data
      }

    case "SAVE_IPM_RESPONSE":
      return {
        ...state, nextButtonIPM: action.data
      }

    case "ACCORDION_COMPLETED":
      return {
        ...state, [action.data.key]: action.data.value
      }

    case "UPDATE_RETRY_COUNT":
      return {
        ...state, creditCheck: { ...state.creditCheck, retryCount: action.data }
      }

    case "RESERVE_DUEDATE_ERROR":
      return {
        ...state, duedateReserveError: action.message
      };

    case "RESET_RESERVE_DUEDATE_ERROR":
      return {
        ...state, duedateReserveError: ''
      };

    case "UPDATE_CREDIT_CHECK_STATUS":
      return {
        ...state, nextButtonCC: { ...state.nextButtonCC, CreditCheckStatus: action.data }
      }
    case "UPDATE_APENROLLED_STATUS":
      return {
        ...state, APEnrolled: true
      }
    case "SET_APLOADING":
      return {
        ...state, APLoading: action.data
      }
    case "UPDATE_APLOAD_FAILURE":
      return {
        ...state, APLoadFailure: action.data
      }
    case "SAVE_LOA_CONFIRMATION": {
      return {
        ...state, LOAStatus: action.data
      }
    }

    case "UPDATE_INSTALLATION_TYPE": {
      return {
        ...state, SIselected: action.data
      }
    }
    case "UPDATE_SAVED_CART_ERROR": {
      return {
        ...state, savedCartError: action.data
      }
    }
    case "SAVE_CREDIT_CHECK_STATE": {
      return {
        ...state, creditCheckState: action.data
      }
    }
    case "RESET_CHECKOUT_STATE": {
      return {
        ...initialState,
        paymentMethodType:state.paymentMethodType,
        savedPaymentMethodType:state.savedPaymentMethodType,
        installments:state.installments,
        timeSlot:state.timeSlot,
        timeSlotCode:state.timeSlotCode,
        dueDate:state.dueDate,
        tosCheck:state.tosCheck,
        contactInfo: state.contactInfo,
        businessInfo: state.businessInfo,
        shippingInfo: state.shippingInfo,
        creditCheck: {...state.creditCheck,retryCount:0},
        nextButtonCC: state.nextButtonCC,
        isVOCallInProgress: state.isVOCallInProgress
      };
    }

    case "VO_CALL_IN_PROGRESS": {
      return { ...state, isVOCallInProgress: action.data }
    }
    case 'SET_NEW_ADDRESS_FLOW':
      return { ...state, isNewAddressFlow: action.data };
    case "CHECKOUT_INITIATED": {
      return { ...state, isCheckoutInitiated: action.data }
    }
    case "AUTOPAY_PAYMENT_METHOD_RESPONSE": 
      return {
        ...state, autoPayMethodSaveResponse: action.data
      }
      case "UPDATE_TOS_INFO_NOR":
        return {
          ...state, [action.data.key]: action.data.value
      }
      case "IS_RESET_DATE_CHANGE":      
      return {
        ...state,
        isResetDateChange: action.data
      };
      case 'SAVE_SELECTED_STREET_ADDRESS':{
        let infos=action.data;
        let obj={
          ...state.contactInfo,
          address: infos?.dispstr,
          city: infos?.muni,
          state: infos?.state,
          zipCode: infos?.zip,
        }
        return { ...state, contactInfo: {...state.contactInfo,...obj}
          }
      }
      case 'UPDATE_PAYMENT_METHOD_TYPE':{
        return {...state,paymentMethodType:action.data}
      }
      case "UPDATE_SAVED_PAYMENT_METHOD_TYPE":{
        return {...state,savedPaymentMethodType:action.data}
      }
      case 'UPDATE_INSTALLMENTS_VDS3_LF':{
        return {...state,installments:{...state.installments,...action.data}}
      }
      case "SHOW_CREDIT_CHECK_PROGRESS":{
        return {...state,enableVDS3LFCreditCheckProgress:action.data}
      }
      case 'SET_CREDIT_CHECK_LBO':{
        return {...state,isCreditCheckLBO:action?.data}
      }  
      case 'SET_CREDIT_CHECK_LBO':{
        return {...state,isCreditCheckLBO:action?.data}
      }
    default:
      return state;
  }
};
export default reducer;
